import { motion } from "framer-motion";
import { useLenis } from "lenis/react";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({
  children,
  delay = 0,
  y = 32,
  className = "",
  once = true,
}) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for headlines
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="reveal-mask block -my-[0.1em] py-[0.1em]">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

// Hook for lenis-powered anchor scrolling
export const useScrollTo = () => {
  const lenis = useLenis();
  return (target) => {
    const el = document.querySelector(target);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -84, duration: 1.2 });
    else el.scrollIntoView({ behavior: "smooth" });
  };
};

export { EASE };
